import { getDefaultMargin, getDefaultMarginOverlay } from '../utils'

export const IconDesignSettings = {
  'icon-button-design-icon-size': {
    phone: [48],
    'phone-landscape': [48],
    tablet: [48],
    'tablet-landscape': [48],
    desktop: [48],
    tv: [48],
  },
  'icon-button-design-h-align': {
    phone: 'parent',
    'phone-landscape': 'parent',
    tablet: 'parent',
    'tablet-landscape': 'parent',
    desktop: 'parent',
    tv: 'parent',
  },
  'icon-button-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
    overflowSetting: getDefaultMarginOverlay,
  },
  'icon-button-design-padding': {
    phone: getDefaultMargin([16]),
    'phone-landscape': getDefaultMargin([16]),
    tablet: getDefaultMargin([16]),
    'tablet-landscape': getDefaultMargin([16]),
    desktop: getDefaultMargin([16]),
    tv: getDefaultMargin([16]),
  },

  'icon-button-design-icon-color-variant': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'icon-button-design-icon-inactive-color': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'icon-button-design-active-color': {
    light: 'adaptive',
    dark: 'adaptive',
  },
  'icon-button-design-active-color-solid': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'icon-button-design-inactive-color': {
    light: 'adaptive',
    dark: 'adaptive',
  },
  'icon-button-design-inactive-color-solid': {
    light: 'primary-40',
    dark: 'primary-40',
  },
}
